module.exports.DEFAULT_LOCALE = 'EN'
module.exports.WEBCAM_FILES_URL = 'https://webcam.life/files'
